import { Directive, ElementRef, OnInit, Input } from '@angular/core';
import {  UserService } from '@bt/core';

@Directive({
    selector: '[myDisableIfHasNotPermission]'
})
export class MyDisableIfHasNotPermissionDirective implements OnInit {
    @Input('myDisableIfHasNotPermission') permission : string;  // Required permission passed in

    constructor(private el: ElementRef,
        private userService: UserService
        ) { }

    ngOnInit() {
        if (!this.verifyRole(this.permission)) {
            this.el.nativeElement.disabled = true;
        }
    }
    
    public verifyRole(rolesStr:string) : boolean{
        if(!rolesStr){
            return false;
        }
        var roles = rolesStr.split(',');
        if(roles.indexOf(this.userService.getRole().toString())==-1 ) {
            return false;
        }
        else {
            return true;
        }
    }
}






// WEBPACK FOOTER //
// ./src/app/directives/disable.directive.ts